export default(boardMembers, min) => ({
  id: 0,
  minmum: min,
  board_members: boardMembers,
  addBoardMember() {
    this.board_members.push({
      first_name: '',
      bank_employee: false,
      last_name: '',
      title: '',
      id: this.id
    });
    this.id++;
  },
  removeBoardMember(id) {
    this.board_members = this.board_members.filter(b => b.id !== id);
    if (this.board_members.length < this.minmum) {
      this.addBoardMember();
    }
  },
  init() {
    if (this.board_members.length > 0) {
      this.id = this.board_members.length + 1;
    }
  }
});
